import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { map } from "rxjs/operators";
import { NotificationService } from "src/app/notification.service";
import { BaseEntityService } from "../rest-common.service";
import { of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TdspGeoService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  validatePostalCodes(data, params = {}) {
    let url = this.buildUrl(`${this.BASE_TDSP_URL}/static/validate-postal-codes/`, "", params);
    return this.post(url, data);
  }

  getGamblingCountries(params = {}) {
    let url = this.buildUrl(`${this.BASE_TDSP_URL}/static/gambling-countries/`, "", params);
    return this.get(url);
  }

  saveGamblingCountries(data, params = {}) {
    let url = this.buildUrl(`${this.BASE_TDSP_URL}/static/gambling-countries/`, "", params);
    return this.post(url, data);
  }
}